(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/assets/hooks/use-active-competition-details.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/assets/hooks/use-active-competition-details.js');
"use strict";

const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const useActiveCompetitionId = svs.components.marketplaceCompetition.services.hooks.useActiveCompetitionId;
const selectCompetitionDetails = svs.components.marketplaceCompetition.services.selectors.competitionSelectors.selectCompetitionDetails;
const useActiveCompetitionDetails = () => {
  const activeCompetitionId = useActiveCompetitionId();
  return useSelector(state => selectCompetitionDetails(state, activeCompetitionId));
};
setGlobal('svs.components.marketplaceCompetition.services.hooks.useActiveCompetitionDetails', useActiveCompetitionDetails);

 })(window);